import api from '@/utils/api';

/**
 * Import customers
 * @param {string} fileName - the file to import
 * @returns {Promise}
 */
const importCustomersApi = (fileName) =>
  api.post('/customer/import', { fileName });

export default importCustomersApi;
